import { Component } from '@angular/core';

@Component({
  selector: 'app-cisterna-no-selected',
  templateUrl: './cisterna-no-selected.component.html',
  styleUrls: ['./cisterna-no-selected.component.css'],
})
export class CisternaNoSelectedComponent {}
